import React, { useState } from 'react'
import { MDBBtn } from 'mdb-react-ui-kit'
import RestApi from '../../../../api/automation-api-client'
import UserProfileService from '../../../../shared/services/UserProfile.service'

const BroadcastTrigger = () => {
  const [agentId, setAgentId] = useState(UserProfileService.getUserId() || '')
  const [payload, setPayload] = useState('{"hello":"world"}')
  const [status, setStatus] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const fire = async () => {
    setStatus(null)
    let parsedPayload
    try {
      parsedPayload = payload ? JSON.parse(payload) : {}
    } catch (e) {
      setStatus({ ok: false, message: `Invalid JSON: ${e.message}` })
      return
    }

    setSubmitting(true)
    try {
      const response = await RestApi.request(
        'POST',
        '/diagnostics',
        null,
        { agent_id: parseInt(agentId, 10), payload: parsedPayload },
        { endpoint: '/diagnostics/broadcast-test' }
      )
      setStatus({ ok: true, message: JSON.stringify(response, null, 2) })
    } catch (e) {
      setStatus({ ok: false, message: `${e}` })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className='ws-card'>
      <h5>Fire Test Broadcast</h5>
      <div className='form-group'>
        <label className='small mb-1'>Target Agent ID</label>
        <input
          type='number'
          className='form-control form-control-sm'
          value={agentId}
          onChange={e => setAgentId(e.target.value)}
          placeholder='42'
        />
      </div>
      <div className='form-group'>
        <label className='small mb-1'>Payload (JSON)</label>
        <textarea
          className='form-control form-control-sm'
          rows='3'
          value={payload}
          onChange={e => setPayload(e.target.value)}
        />
      </div>
      <MDBBtn
        type='button'
        size='sm'
        color='primary'
        onClick={fire}
        disabled={submitting || !agentId}
        className='w-100'
      >
        {submitting ? 'Firing…' : 'Fire diagnostic.test'}
      </MDBBtn>
      {status && (
        <div className={`mt-2 small ${status.ok ? 'text-success' : 'text-danger'}`}>
          <pre className='mb-0' style={{ fontSize: 11, whiteSpace: 'pre-wrap' }}>
            {status.message}
          </pre>
        </div>
      )}
      <div className='mt-2 small text-muted'>
        Subscribe to <code>private-diagnostics.agent.{agentId || '<id>'}</code> to see this event arrive.
      </div>
    </div>
  )
}

export default BroadcastTrigger
